import { render, staticRenderFns } from "./takeanexam.vue?vue&type=template&id=0a9b7866&scoped=true"
import script from "./takeanexam.vue?vue&type=script&lang=js"
export * from "./takeanexam.vue?vue&type=script&lang=js"
import style0 from "./takeanexam.vue?vue&type=style&index=0&id=0a9b7866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b7866",
  null
  
)

export default component.exports